import { Fade, Slide, useTheme } from '@ori-ui/mui-bundle/material';
import { forwardRef, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const Transition = /*#__PURE__*/forwardRef((props, ref) => {
  const theme = useTheme();
  const [screenWidth, setScreenWidth] = useState(400);
  useEffect(() => {
    setScreenWidth(window.innerWidth);
    function handleResize() {
      setScreenWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  if (screenWidth >= theme.breakpoints.values.sm) {
    return /*#__PURE__*/_jsx(Fade, {
      ref: ref,
      ...props
    });
  }
  return /*#__PURE__*/_jsx(Slide, {
    ref: ref,
    direction: "up",
    ...props
  });
});
//# sourceMappingURL=Transition.js.map